/**
 * StructuredData Component
 * Inyecta datos estructurados JSON-LD sin impacto visual
 * Para mejorar SEO con Schema.org
 */

import React from 'react';
import { Helmet } from 'react-helmet-async';

interface StructuredDataProps {
  data: Record<string, any> | Record<string, any>[];
}

/**
 * Componente invisible que inyecta datos estructurados
 * No afecta el diseño visual de la página
 */
export const StructuredData: React.FC<StructuredDataProps> = ({ data }) => {
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(data, null, 0)}
      </script>
    </Helmet>
  );
};

export default StructuredData;